import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import Loading from "components/Loading";
import useCallApi from "hook/useCallApi";
import { getDropShipping, callFavorite, addSystems, getXffbbWarehouses } from "actions/dropshippingActions";
import ProductFilter from "./filter";
import ProductDropDetail from "./detail";
import ModalCreate from "./modalCreate";
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";

const limit = 20;

const formatStockStores = (stockStores = []) => {
    if (!Array.isArray(stockStores) || !stockStores.length) return "";
    return stockStores.map((store) => `${store?.store_name}: ${store?.all_no}`).join(", ");
};

const getWarehouseAddress = (warehouse) => {
    return [warehouse?.street1, warehouse?.street2, warehouse?.city, warehouse?.state, warehouse?.zip, warehouse?.country]
        .filter(Boolean)
        .join(", ");
};

const DropShippingList = ({ getDropShipping, callFavorite, addSystems, getXffbbWarehouses, source }) => {
    const [page, setPage] = useState(0);
    const [filter, setFilter] = useState({});
    const [search, setSearch] = useState("");
    const [productSelect, setProductSelect] = useState(null);
    const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
    const [isFavorite, setIsFavorite] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [productSave, setProductSave] = useState(null);
    const params = useMemo(
        () => ({ limit, offset: page * limit, ...filter, source, isFavorite }),
        [page, filter, source, isFavorite]
    );
    const warehouseParams = useMemo(() => ({}), []);
    const { data, loading: isLoading, reload } = useCallApi(getDropShipping, params);
    const { data: warehouseResponse } = useCallApi(getXffbbWarehouses, warehouseParams);
    const warehouses = useMemo(() => warehouseResponse?.data || warehouseResponse || [], [warehouseResponse]);
    const warehouseOptions = useMemo(
        () =>
            warehouses.map((warehouse) => ({
                value: warehouse.id,
                label: warehouse.name,
            })),
        [warehouses]
    );

    const { t } = useTranslation();

    const updateFavorite = async (productId) => {
        await callFavorite({ productId, source });
        reload();
    };

    const handleSave = async (data) => {
        setSaveLoading(true);
        await addSystems({ ...data, productId: productSave?.product_id, source });
        setSaveLoading(false);
    };

    return (
        <div className="card mb-5 mb-xl-12 container">            
            <div className="row mt-5">
                <button
                    type="button"
                    className="btn btn-light-primary fw-bold d-inline-flex align-items-center gap-2"
                    onClick={() => setIsWarehouseModalOpen(true)}
                    style={{ width: "fit-content" }}
                >
                    <i className="fas fa-hand-point-right"></i>
                    Warehouse Require
                </button>
            </div>
            <div className="d-flex gap-4 mt-3" style={{ minHeight: "40px" }}>
                <div className="col-md-3">
                    <div className="input-group h-100">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <button
                            className="btn btn-info btn-sm"
                            type="button"
                            onClick={() => {
                                setPage(0);
                                setFilter((prev) => ({ ...prev, search }));
                            }}
                        >
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </div>
                <div className="col-md-3 d-flex gap-4 align-items-center">
                    <ProductFilter
                        warehouseOptions={warehouseOptions}
                        setQueryFilter={(f) => {
                            setPage(0);
                            setFilter((prev) => ({ ...prev, ...f }));
                        }}
                    />
                    <span
                        role="button"
                        onClick={() => {
                            setPage(0);
                            setIsFavorite(!isFavorite);
                        }}
                    >
                        <i
                            className={`ki-duotone ki-heart-circle ${isFavorite && "text-warning"}`}
                            style={{ fontSize: "30px" }}
                        >
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>
                </div>
            </div>
            <div className="row mt-3">                
                <h4>{"-> "}<Link to="https://www.youtube.com/watch?v=vEHyvZvsSoE" target="_blank">How to Listing? Click here, view video!</Link></h4>
                <h4>{"-> "}<Link to="https://youtu.be/OMWuq-GkiuE" target="_blank">How to Fulfillment? Click here, view video!</Link></h4>
            </div>
            <div className="row mt-3">
                {(data?.items || []).map((product, index) => (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={product.product_id}>
                        <div className="card h-100 shadow-sm border rounded">
                            <div className="w-100" style={{ height: "180px", overflow: "hidden" }}>
                                <img
                                    src={
                                        product?.images?.[0]?.image_url
                                            ? product?.images?.[0]?.image_url
                                            : product?.images?.[1]?.image_url
                                    }
                                    alt={product?.title}
                                    className="w-100 h-100 mt-2"
                                    style={{ objectFit: "contain" }}
                                />
                            </div>

                            <div className="card-body d-flex flex-column justify-content-between">
                                <div>
                                    <h5 className="text-danger fw-bold mb-1 d-flex justify-content-between">
                                        <span>{product?.price} </span>
                                    </h5>
                                    <h6
                                        className="text-truncate"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={product?.title}
                                    >
                                        {product?.title}
                                    </h6>
                                    <p className="text-muted mb-1 small">ID: {product?.product_id}</p>
                                    <p className="text-info mb-1 small">Category: {product?.category_name}</p>
                                    {/* <p className="text-primary mb-0 small">
                                        Inventory: {product?.warehouse}{" "}
                                        <span
                                            className="text-danger"
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content={t("Total Stock")}
                                        >
                                            ({product?.stock_quantity})
                                        </span>
                                    </p> */}
                                    <p className="text-dark mb-1 small">
                                        From: ${product?.sell_price || product?.variants?.[0].sell_price?.toFixed(2)}{" "}
                                        <span
                                            className="text-danger"
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content={t("Total Stock")}
                                        >
                                            ({product?.stock_quantity})
                                        </span>
                                        {Boolean(product?.stock_stores?.length) && (
                                            <span
                                                className="text-muted"
                                                data-tooltip-id="my-tooltip"
                                                data-tooltip-content={formatStockStores(product?.stock_stores)}
                                            >
                                                {" "}
                                                {product.stock_stores.map((store) => store?.store_name).filter(Boolean).join(", ")}
                                            </span>
                                        )}
                                    </p>
                                </div>

                                <div className="d-flex align-items-center gap-2 mt-3 w-100">
                                    <button
                                        className="btn btn-primary flex-1 flex-grow-1 flex-shrink-1"
                                        onClick={() => setProductSave(product)}
                                    >
                                        Save
                                    </button>
                                    <button
                                        onClick={() => setProductSelect(product)}
                                        className="btn btn-info flex-1 flex-grow-1 flex-shrink-1"
                                    >
                                        Detail
                                    </button>
                                    <span role="button" onClick={() => updateFavorite(product?.product_id)}>
                                        <i
                                            className={`ki-duotone ki-heart-circle ${product.isFavorite && "text-warning"
                                                }`}
                                            style={{ fontSize: "30px" }}
                                        >
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="ag-theme-alpine">
                <div className="al-form-input-date mb-5 ag-grid-paginate-custom">
                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={(page) => {
                            setPage(page?.selected || 0);
                        }}
                        pageRangeDisplayed={2}
                        pageCount={data?.total ? Math.ceil(data?.total / limit) : 1 || 0}
                        marginPagesDisplayed={1}
                        renderOnZeroPageCount={null}
                        forcePage={page}
                        nextLabel={
                            <div
                                className="ag-button ag-paging-button mt-1"
                                role="button"
                                aria-label="Next Page"
                                tabIndex={0}
                                aria-disabled="true"
                            >
                                <span className="ag-icon ag-icon-next" unselectable="on" role="presentation" />
                            </div>
                        }
                        previousLabel={
                            <div
                                className="ag-button ag-paging-button mt-1"
                                role="button"
                                aria-label="Previous Page"
                                tabIndex={0}
                                aria-disabled="true"
                            >
                                <span className="ag-icon ag-icon-previous" unselectable="on" role="presentation" />
                            </div>
                        }
                    />
                </div>
            </div>
            <Loading isLoading={isLoading || saveLoading} />
            <ProductDropDetail
                isOpen={Boolean(productSelect)}
                product={productSelect}
                onClose={() => setProductSelect(null)}
            />
            <ModalCreate
                isOpen={Boolean(productSave)}
                onClose={() => setProductSave(null)}
                product={productSave}
                onSubmit={handleSave}
            />
            <Modal
                centered={true}
                size="xl"
                isOpen={isWarehouseModalOpen}
                toggle={() => setIsWarehouseModalOpen(false)}
            >
                <ModalBody className="p-0">
                    <div className="px-8 pt-6 pb-5 border-bottom">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h3 className="mb-1 text-dark">Warehouses Required</h3>
                                <p className="mb-0 text-muted">Total warehouses: {warehouses.length}</p>
                                <p className="mb-0 text-warning">
                                    Product warehouse must match at least the first 3 digits of the ZIP code.
                                </p>
                            </div>
                            <button
                                type="button"
                                className="btn btn-sm btn-icon btn-active-color-primary"
                                onClick={() => setIsWarehouseModalOpen(false)}
                            >
                                <i className="ki-outline ki-cross fs-1"></i>
                            </button>
                        </div>
                    </div>
                    <div className="px-8 py-6">
                        <div className="row g-4">
                            {warehouses.map((warehouse) => (
                                <div className="col-12 col-md-6 col-lg-4" key={warehouse.id}>
                                    <div className="border rounded p-5 h-100 position-relative">
                                        <span className="badge badge-light position-absolute top-0 end-0 mt-4 me-4">
                                            #{warehouse.id}
                                        </span>
                                        <h5 className="text-dark mb-4">{warehouse.name}</h5>
                                        <p className="mb-1 text-muted">
                                            <strong>Contact:</strong> {warehouse.contact}
                                        </p>
                                        <p className="mb-1 text-muted">
                                            <strong>Phone:</strong> {warehouse.phone}
                                        </p>
                                        <p className="mb-0 text-muted">
                                            <strong>Address:</strong> {getWarehouseAddress(warehouse)}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    getDropShipping,
    callFavorite,
    addSystems,
    getXffbbWarehouses,
};

export default connect(mapStateToProps, mapDispatchToProps)(DropShippingList);
